module.exports = __webpack_public_path__ + "img/service-zhinengcuishou3.a559f2e1.svg";